import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

  header: () => {
    return  {
      [theme.breakpoints.up('xs')]: {
        minHeight: '50px',

      },

      [theme.breakpoints.down('xs')]: {
        width: 'calc(100% - 32px)',
      },

      width: '100%',
      display: 'flex',
      flexDirection: 'column !important', 
      maxHeight: '220px',
      alignItems: 'center',
    };
  },

  title: ({ error, commonUIStyles, widget, hasCustomCSS }) => {

    function color () {
      // if (hasCustomCSS) {
      //   return {};
      // }
      return  commonUIStyles.headerTitleText({ error, widget });
    }
  
    return  {
      [theme.breakpoints.down('xs')]: {
         fontSize: '22px',
         textAlign: 'center',
      },

      width: 'calc(100% - 24px)',
      display: 'flex',
      fontSize: '1.6em',
      fontWeight: 350,
      color: color(),
      minHeight: '32px',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    };
  },

  intro: () => {
    return  {
      maxWidth: '500px',
      flexDirection: 'column !important',
      fontSize: '16px',
      lineHeight: '1.2rem',
      margin: '2px 0px 0px 0px',
      justifyContent: 'center',
      textAlign: 'center',
      fontWeight: 300,
      color: '#0C0644',
      overflow: 'hidden',
      display: '-webkit-box',
      /*
      '-webkit-line-clamp': 3,
      '-webkit-box-orient': 'vertical',
      textOverflow: 'ellipsis',
      */
    };
  },

  termsAndPrivacyBox: () => {
    return  {
      maxWidth: '500px',
      display: 'flex',
      fontSize: '1rem',
      lineHeight: '1.2rem',
      justifyContent: 'center',
      textAlign: 'center',
      fontWeight: 300,
      margin: '0.5em',
    };
  },

  termsAndPrivacyPTag: () => {
    return  {
      margin: 0,
    };
  },

  lineDivider: () => {
    return  {
      display: 'block',
      height: '1px',
      width: '320px',
      border: '0',
      borderTop: '1px solid #CAC4D0',
      padding: '0',

      [theme.breakpoints.down('xs')]: {
        width: '100%',
     },
    };
  },

});

export default styles;
export const useStyles = makeStyles(styles);
